import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { IIssuer } from '@bca-agreement/models/issuer';

@Component({
  selector: 'bca-choose-issuer',
  templateUrl: 'choose-issuer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChooseIssuerComponent {
  @Input()
  selectedIssuerId: string;
  @Input()
  issuers: IIssuer[];
  @Input()
  issuerRequiredError: boolean;

  @Output()
  selected = new EventEmitter<string>();
}
